module.exports = __webpack_public_path__ + "img/kdsLog.1351c450.png";